module.exports = __webpack_public_path__ + "static/media/jirou-kyouka.931a4dec.png";